import { PLAN_SLOTS, visiblePlanKeys } from '@/stores/useStore'

const PASS_STATUSES = new Set([
  'within-basic-threshold',
  'passes',
  'pass',
  'not-top-heavy',
  'passes-ratio',
  'passes-average-benefit',
])

const FLAG_STATUSES = new Set([
  'over-basic-threshold',
  'under-basic-threshold',
  'fails',
  'fail',
  'top-heavy',
  'fails-ratio',
  'fails-average-benefit',
])

export function modeledCheckTone(status) {
  if (PASS_STATUSES.has(status)) return 'pass'
  if (FLAG_STATUSES.has(status)) return 'flag'
  return 'needs-data'
}

export function summarizeModeledChecks(entries = []) {
  const checks = entries.flatMap((entry) => {
    const metrics = entry?.analysis?.metrics || entry?.metrics || {}
    return [
      metrics.informalAdpAvailable ? metrics.informalAdpStatus : 'unavailable',
      metrics.informalCoverageAvailable ? metrics.informalCoverageStatus : 'unavailable',
      ...(metrics.crossTestingApplicable ? [metrics.crossTestingStatus] : []),
      metrics.topHeavyAvailable ? metrics.topHeavyStatus : 'unavailable',
    ]
  })

  const counts = checks.reduce((result, status) => {
    result[modeledCheckTone(status)] += 1
    return result
  }, { pass: 0, flag: 0, 'needs-data': 0 })

  const issueCount = counts.flag + counts['needs-data']
  const status = counts.flag > 0
    ? 'review'
    : counts['needs-data'] > 0
      ? 'incomplete'
      : 'clear'

  const label = counts.flag > 0
    ? `${counts.flag} modeled check ${counts.flag === 1 ? 'flag' : 'flags'} to review`
    : counts['needs-data'] > 0
      ? `${counts['needs-data']} ${counts['needs-data'] === 1 ? 'check needs' : 'checks need'} more data`
      : 'No modeled check flags'

  return {
    passCount: counts.pass,
    flagCount: counts.flag,
    needsDataCount: counts['needs-data'],
    issueCount,
    status,
    label,
  }
}

export function modeledCheckSummaryForState(state) {
  const visible = new Set(visiblePlanKeys(state))
  const entries = PLAN_SLOTS
    .filter((key) => state[key] && visible.has(key))
    .map((key) => ({ key, analysis: state.analysis?.[key] }))
  return summarizeModeledChecks(entries)
}
